import React, { Component } from 'react';
import './css/docs.css';

function bashCode(string){
  return inlineCode(string, 'bash');
}

function javaCode(string){
  return inlineCode(string, 'java');
}

function XMLCode(string){
  return inlineCode(string, 'xml');
}

function inlineCode(string, language){
  let htmlLines = string.split('\n')
        .map(line => line)//.replace(/\s/g,'&nbsp'))
        .map(line => {
          return <div>
            {`${line}`}
          </div>;
        });
  
  return (
    <pre>
      <code className={language}>
        {htmlLines}
      </code>
    </pre>);
}

export default class Docs extends Component{

  constructor(props){
    super(props);

    if (this.props.clientId){
        this.state = {
          clientId: this.props.clientId
        };      
    } else {      
      if (this.props.apps && this.props.apps.length > 0){
        this.state = {
          clientId: this.props.apps[0].clientId
        };
      }
    }
  }
  
  componentDidMount(){

    document.querySelectorAll('pre code')
      .forEach(el => window.hljs.highlightBlock(el));

    // window.$('#table-contents').affix({
    //   offset: {
    //     top: 10,
    //     bottom: 0
    //   }
    // });

    window.$('body')
      .scrollspy({
        target: '#table-contents',
        offset: 200
      });

    
  }
  
  render() {

    let apiKey = this.state.clientId;
    
    return (
      <div id="docs" className="row">

        <div className="col-md-3 pull-right">
          <div id="table-contents">
            <h4>Table Of Contents</h4>
            <ul className="nav">
              <li className="active">
                <a href="#api-key">API Key</a>
              </li>
              <li>
                <a href="#sdk-integrate">Download and integrate SDK</a>
              </li>
              <li>
                <a href="#android-manifest">AndroidManifest.xml</a>
              </li>
              <li>
                <a href="#sdk-integration">SDK Integration</a>
                <ul className="nav">
                  <li>
                    <a href="#sdk-init">SDK Initialization</a>
                  </li>
                  <li>
                    <a href="#sdk-cb">Using Interstitial callbacks</a>
                  </li>
                  <li>
                    <a href="#sdk-proguard">Proguard Settings</a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#legal">Legal Requirements</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="col-md-9 pull-left">
         <div id="docs-text">
          <h1>SDK Integration</h1>
          <a href="githiub.com">Integration sample</a>

          <h2 id="api-key">1. App key</h2>

          <label className="control-label">
            Select App:
          </label>
          <select className="form-control"
                  onChange={e => {
                    this.setState({
                      clientId: e.target.value
                    });
            }}>
            {this.props.apps.map((app,idx) => {
              return (
                <option
                  key={idx}
                  value={app.clientId}
                  selected={app.clientId == this.state.clientId}>
                {app.name}
                </option>);
            })}
          </select>
          <pre>
            Api Key: {this.state.clientId}
          </pre>
          
          <h2 id="sdk-integrate">2. Download and integrate SDK</h2>
          Download the SDK from our repository

          <div>
            {inlineCode('git clone https://github.com/Mobbo-com/AppBid-Android-SDK', 'bash')}
            </div>

          {`Add AppBid library to your project(File->New->Import module):`}

          <img src="http://appbid.com/img/android/import_new_module.png"/>

          <img src="http://appbid.com/img/android/import_module_dialog.png"/>

          
          <h2 id="android-manifest">3. AndroidManifest.xml</h2>
          Add the following to your AndroidManifest.xml under manifest tag:

          <div>{XMLCode(`<uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" />
<uses-permission android:name="android.permission.INTERNET" />
<uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /> <!--optional -->
<uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /> <!--optional -->
<uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /> <!--optional-->`)}</div>
                              
          Add the following under application tag:
          <div>
            { XMLCode(`<!-- Chartboost -->
<activity android:name="com.chartboost.sdk.CBImpressionActivity"
    android:excludeFromRecents="true"
    android:hardwareAccelerated="true"
    android:theme="@android:style/Theme.Translucent.NoTitleBar.Fullscreen"
    android:configChanges="keyboardHidden|orientation|screenSize" />

<!-- MoPub -->
<activity android:name="com.mopub.mobileads.MoPubActivity" android:configChanges="keyboardHidden|orientation|screenSize"/>
<activity android:name="com.mopub.mobileads.MraidActivity" android:configChanges="keyboardHidden|orientation|screenSize"/>
<activity android:name="com.mopub.common.MoPubBrowser" android:configChanges="keyboardHidden|orientation|screenSize"/>
<activity android:name="com.mopub.mobileads.MraidVideoPlayerActivity" android:configChanges="keyboardHidden|orientation|screenSize"/>
<activity android:name="com.mopub.mobileads.RewardedMraidActivity" android:configChanges="keyboardHidden|orientation|screenSize"/>

<!-- Flurry Advertising -->
<activity
    android:name="com.flurry.android.FlurryFullscreenTakeoverActivity"
    android:configChanges="keyboard|keyboardHidden|orientation|screenLayout|uiMode|screenSize|smallestScreenSize" />

<!-- Applovin -->
<activity android:name="com.applovin.adview.AppLovinInterstitialActivity" android:configChanges="orientation|screenSize"/>
<activity android:name="com.applovin.adview.AppLovinConfirmationActivity" android:configChanges="orientation|screenSize"/>

<!-- Amazon ads -->
<activity android:name="com.amazon.device.ads.AdActivity" android:configChanges="keyboardHidden|orientation|screenSize"/>


<!-- Unity ADS -->
<activity
    android:name="com.unity3d.ads.adunit.AdUnitActivity"
    android:configChanges="fontScale|keyboard|keyboardHidden|locale|mnc|mcc|navigation|orientation|screenLayout|screenSize|smallestScreenSize|uiMode|touchscreen"
    android:hardwareAccelerated="true"
    android:theme="@android:style/Theme.NoTitleBar.Fullscreen" />
<activity
    android:name="com.unity3d.ads.adunit.AdUnitSoftwareActivity"
    android:configChanges="fontScale|keyboard|keyboardHidden|locale|mnc|mcc|navigation|orientation|screenLayout|screenSize|smallestScreenSize|uiMode|touchscreen"
    android:hardwareAccelerated="false"
    android:theme="@android:style/Theme.NoTitleBar.Fullscreen" />

<!-- StartApp -->
<activity android:name="com.startapp.android.publish.ads.list3d.List3DActivity"
    android:theme="@android:style/Theme" />

<activity android:name="com.startapp.android.publish.adsCommon.activities.OverlayActivity"
    android:theme="@android:style/Theme.Translucent"
    android:configChanges="orientation|keyboardHidden|screenSize" />

<activity android:name="com.startapp.android.publish.adsCommon.activities.FullScreenActivity"
    android:theme="@android:style/Theme"
    android:configChanges="orientation|keyboardHidden|screenSize" />

<service android:name="com.startapp.android.publish.common.metaData.PeriodicMetaDataService" />
<service android:name="com.startapp.android.publish.common.metaData.InfoEventService" />

<!-- InMobi -->
<activity
    android:name="com.inmobi.rendering.InMobiAdActivity"
    android:configChanges="keyboardHidden|orientation|keyboard|smallestScreenSize|screenSize|screenLayout"
    android:hardwareAccelerated="true"
    android:resizeableActivity="false"
    android:theme="@android:style/Theme.NoTitleBar"
   tools:ignore="UnusedAttribute" />`)}</div>


          <h2 id="sdk-integration">4. SDK Integration</h2>
          <h3 id="sdk-init">4.1. SDK Initialization</h3>
          To initialize SDK, you need to add the following code in onCreate method of your main activity:

          <div>
            {javaCode(`String apikey = "YOUR_API_KEY_HERE";
AppBid.initialize(this, apikey);
`)}
          </div>

          To display interstitial without wating to any callback you need to call the following code in activity:

          <div>
            {javaCode(`AppBid.loadWithAutoShow();`)}
          </div>

          <h3 id="sdk-cb">4.2. Using Interstitial callbacks</h3>
          <div>
            {javaCode(`
AppBid.setAdListener(new AdListener() {
    @Override
    public void onAdLoaded() {
        AppBid.showLoadedAd();
    }

    @Override
    public void onAdFailed() {

    }

    @Override
    public void onAdOpened() {

    }

    @Override
    public void onAdClicked() {

    }

    @Override
    public void onAdClosed() {

    }
});

AppBid.load();`)}
          </div>

          
          <h3 id="sdk-proguard">4.3. Proguard Settings</h3>
          If you are using Proguard add the following to your Proguard config file:

          <div>
            {inlineCode(`
# AppBid
-keep class com.appbid.AppBid** { *; }
-keep class com.appbid.AdListener** { *; }

# Tests
-dontwarn android.test.**
-dontwarn android.support.test.**
-dontwarn org.junit.**
-dontwarn org.hamcrest.**
-dontwarn com.squareup.javawriter.JavaWriter
-dontwarn org.mockito.**

# Amazon
-keep class com.amazon.** { *; }
-dontwarn com.amazon.**

# Mopub
-keep public class com.mopub.**
-keepclassmembers class com.mopub.** { public *; }
-dontwarn com.mopub.**
-keep class * extends com.mopub.mobileads.CustomEventBanner {}
-keepclassmembers class com.mopub.mobileads.CustomEventBannerAdapter {!private !public !protected *;}
-keep class * extends com.mopub.mobileads.CustomEventInterstitial {}
-keep class * extends com.mopub.nativeads.CustomEventNative {}
-keep class * extends com.mopub.mobileads.CustomEventRewardedVideo {}
-dontwarn com.mopub.volley.toolbox.**
-keepclassmembers class ** { @com.mopub.common.util.ReflectionTarget *; }

# Applovin
-keep class com.applovin.** { *; }
-dontwarn com.applovin.**

# Facebook
-keep class com.facebook.ads.** { *; }
-keeppackagenames com.facebook.*
-dontwarn com.facebook.ads.**

# Chartboost
-keep class com.chartboost.** { *; }
-dontwarn com.chartboost.**

# Unity Ads
-keepattributes SourceFile,LineNumberTable
-keep class com.unity3d.** { *; }
-dontwarn com.unity3d.**

# StartApp
-keep class com.startapp.** { *;}
-dontwarn com.startapp.**
-keepattributes Exceptions, InnerClasses, Signature, Deprecated, SourceFile, LineNumberTable, *Annotation*, EnclosingMethod

# Flurry
-keep class com.flurry.** { *; }
-dontwarn com.flurry.**
-keepattributes *Annotation*,EnclosingMethod,Signature
-keepclasseswithmembers class * {
  public <init>(android.content.Context, android.util.AttributeSet, int);
}

# Admob
-keep class com.google.android.gms.ads.** { *; }

# Inmobi
-keep class com.inmobi.** { *; }
-dontwarn com.inmobi.**
-dontwarn com.squareup.picasso.**
-keep class com.squareup.picasso.** {*;}
-dontwarn com.squareup.picasso.**
-dontwarn com.squareup.okhttp.**
-keep class com.moat.** {*;}
-dontwarn com.moat.**

# MMdeia
-keepclassmembers class com.millennialmedia** {public *;}
-keep class com.millennialmedia**
-dontwarn com.millennialmedia.**

-keepattributes *Annotation*
-keepattributes JavascriptInterface
-keepclassmembers class * {
  @android.webkit.JavascriptInterface <methods>;
}
-dontnote okhttp3.**
-dontnote okio.**
-dontwarn okhttp3.**
-dontwarn okio.**
-dontwarn javax.annotation.Nullable
-dontwarn javax.annotation.ParametersAreNonnullByDefault

-dontnote sun.misc.Unsafe
-dontnote android.net.http.*

-dontnote org.apache.commons.codec.**
-dontnote org.apache.http.**

-dontwarn org.apache.commons.collections.BeanMap
-dontwarn java.beans.**
-dontnote com.google.gson.**
-keepclassmembers class * implements java.io.Serializable {
  static final long serialVersionUID;
  private static final java.io.ObjectStreamField[] serialPersistentFields;
  private void writeObject(java.io.ObjectOutputStream);
  private void readObject(java.io.ObjectInputStream);
  java.lang.Object writeReplace();
  java.lang.Object readResolve();
}

# Google
-keep class com.google.android.gms.common.GooglePlayServicesUtil {*;}
-keep class com.google.android.gms.ads.identifier.** { *; }
-dontwarn com.google.android.gms.**

# Legacy
-keep class org.apache.http.** { *; }
-dontwarn org.apache.http.**
-dontwarn android.net.http.**

# Google Play Services library
-keep class * extends java.util.ListResourceBundle {
  protected Object[][] getContents();
}
-keep public class com.google.android.gms.common.internal.safeparcel.SafeParcelable {
  public static final *** NULL;
}
-keepnames class * implements android.os.Parcelable
-keepclassmembers class * implements android.os.Parcelable {
  public static final *** CREATOR;
}
-keep @interface android.support.annotation.Keep
-keep @android.support.annotation.Keep class *
-keepclasseswithmembers class * {
  @android.support.annotation.Keep <fields>;
}
-keepclasseswithmembers class * {
  @android.support.annotation.Keep <methods>;
}
-keep @interface com.google.android.gms.common.annotation.KeepName
-keepnames @com.google.android.gms.common.annotation.KeepName class *
-keepclassmembernames class * {
  @com.google.android.gms.common.annotation.KeepName *;
}
-keep @interface com.google.android.gms.common.util.DynamiteApi
-keep public @com.google.android.gms.common.util.DynamiteApi class * {
  public <fields>;
  public <methods>;
}
-keep class com.google.android.gms.common.GooglePlayServicesNotAvailableException {*;}
-keep class com.google.android.gms.common.GooglePlayServicesRepairableException {*;}

# Google Play Services library 9.0.0 only
-dontwarn android.security.NetworkSecurityPolicy
-keep public @com.google.android.gms.common.util.DynamiteApi class * { *; }

# support-v4
-keep class android.support.v4.app.Fragment { *; }
-keep class android.support.v4.app.FragmentActivity { *; }
-keep class android.support.v4.app.FragmentManager { *; }
-keep class android.support.v4.app.FragmentTransaction { *; }
-keep class android.support.v4.content.ContextCompat { *; }
-keep class android.support.v4.content.LocalBroadcastManager { *; }
-keep class android.support.v4.util.LruCache { *; }
-keep class android.support.v4.view.PagerAdapter { *; }
-keep class android.support.v4.view.ViewPager { *; }
-keep class android.support.v4.content.ContextCompat { *; }

# support-v7-recyclerview
-keep class android.support.v7.widget.RecyclerView { *; }
-keep class android.support.v7.widget.LinearLayoutManager { *; }`,'ruby')}
          </div>

          <h2 id="legal">5. Legal Requirements</h2>
          By downloading the Appbid SDK, you are granted a limited, non-commercial license to use and review the SDK solely for evaluation purposes. If you wish to integrate the SDK into any commercial applications, you must register an account with Appbid and accept the terms and conditions on the Appbid website.

         </div>          
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/docs.js